import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-07-23'
        tag='Poshmark'
        title='PoshFest 2021 - All about it and What to expect'
      >
        <h3>What is PoshFest? </h3>​
        <p>
          From the daily virtual Posh Parties to the regular Posh N Sip meet-ups, the Poshmark community indeed thrives
          on constant interaction and networking among its members. The most prestigious of these events is the
          much-awaited PoshFest, an informative and fun conference that happens only for two days once a year.{' '}
        </p>
        ​
        <p>
          Pre-pandemic, PoshFest was usually held in a convention center that could accommodate a large, happy crowd.
          Like any other event last year, though, it transitioned from a real-life event to a fully virtual event with
          the same objective of educating entrepreneurs and sellers and building and strengthening relationships among
          the participants.{' '}
        </p>
        ​
        <p>
          This year, Poshmark's annual conference will be held on October 8 and 9 in Orlando, Florida. With its unique
          hybrid setup, PoshFest 2021 offers attendees the choice of participating in person or virtually via Hopin.
          This broadening accessibility is in line with the theme of PoshFest 2021, which is "Connection." If joining
          virtually, it goes without saying that a strong, steady Wi-Fi is a must for you to enjoy the event to the
          fullest, seamlessly.{' '}
        </p>
        ​<h3>How do I get invited? </h3>​
        <p>
          The great thing about PoshFest is that it's open to everyone who is at least 13 years of age. Seasoned
          Poshmark sellers, new Poshers, or even non-members who are strongly interested in the platform but haven't
          explored it yet are welcome to participate in the main conference and the PoshFest events on the side. It is
          also not limited to US or Canadian residents – anyone from any part of the world can join virtually. For
          in-person attendance of participants from overseas, they must check first with their local authority for any
          COVID-19 related travel restrictions to the venue.{' '}
        </p>
        ​<h3>What goes on at PoshFest? </h3>
        <p>
          The year's agenda and complete details for PoshFest 2021 are yet to be released by the Poshmark team as of
          this writing, but according to the available information, sessions boasts such topics as business basics,
          growth strategies, Poshmark tools, marketing and branding, sourcing, and inventory management, among others.
          Poshmark Founder and CEO Manish Chandra himself will conduct the first panel on the first day with the "State
          of the Posh Union."
        </p>
        ​
        <p>
          The two-day event is also peppered with roundtable discussions, and opportunities for networking during the 8
          am to 5 pm conference itself and making personal connections during the festive socials at night. There's a
          Posh N Sip meet-up on the eve of the conference, a Networking Happy Hour on Friday night, and a Posh Party on
          Saturday night.{' '}
        </p>
        ​<h3>What are the Pros? </h3>
        <p>
          Gain insider tips on taking your Poshmark business to the next level. Learn new trends and valuable insights
          from the speakers who are Poshmark leaders and industry experts, as well as your fellow sellers and attendees
          whose Poshmark success stories and practical wisdom might help you enrich your business.{' '}
        </p>
        ​
        <p>
          Be one of the first to know about the new, exciting features that Poshmark will be rolling out. There's a
          session on the second day called "Feature Reveal," especially for this purpose.
        </p>
        <p>
          Get to know in the flesh or through a screen the real person behind the Poshmark closet you adore! Network
          with as many of them as time would allow. Reconnect with your PFFs (Posh Friends Forever) or make new ones and
          nurture these friendships post-event by adding them on social media.
        </p>
        <h3>What are the Cons?</h3>
        <p>
          If you are the type who loves attending workshops and webinars, you might not find any new learnings from
          PoshFest that you have not picked up yet from the previous ones you've attended.
        </p>
        <p>
          This annual conference is open to all, but it comes at a fee that some may balk at. In-person tickets sell for
          $269 (add to that the transportation costs, hotel accommodation, and other incidental expenses), while tickets
          to the virtual PoshFest go for $49. The virtual ticket that comes with a swag bag of goodies costs $89. How
          affordable or expensive these tickets are would depend on you and your capacity and willingness to shell out
          for these types of expenses. Some may write these tickets off as business expenses or simply view them as
          investments under continuous learning and self-development.
        </p>
        ​
        <p>
          Attending Poshmark events is a great way to grow your followers and even help you become a Poshmark
          Ambassador. But it is just one part of the equation. A day in the life of a Poshmark seller involves plenty of
          time spent manually sharing their closet, sharing others', following new sellers, returning follows, and more.
          A brilliant and easy-to-use Poshmark bot such as OneShop does these repetitive tasks even as you sleep – come
          to think of it, that is a smart investment.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
